export const TRACKING_KEY_IMAGE_SCROLL = "tracking.productList.imageScroll";
export const TRACKING_CONTEXT_IMAGE_SCROLL = "imageScroll";
